import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithCalendar_1 from '../../../../../libraries/Images/createAConnectionWithCalendar_1.png';
import createAConnectionWithCalendar_2 from '../../../../../libraries/Images/createAConnectionWithCalendar_2.png';
import createAConnectionWithCalendar_3 from '../../../../../libraries/Images/createAConnectionWithCalendar_3.png';
import createAConnectionWithCalendar_4 from '../../../../../libraries/Images/createAConnectionWithCalendar_4.png';
import createAConnectionWithCalendar_5 from '../../../../../libraries/Images/createAConnectionWithCalendar_5.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithcalendar">
                1.&nbsp;{translate('createaconnectionwithcalendar')}
            </Typography>
            <p>Nhấp vào "Thêm mới" để tạo kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_1} width="75%" />
            </Zoom>
            <p>Một danh sách các ứng dụng có thể được liên kết sẽ hiển thị, hãy chọn "Calendar" trong số đó.</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_2} width="75%" />
            </Zoom>
            <p>Khi bạn nhấp vào "Calendar", màn hình lựa chọn tài khoản Google của người dùng sẽ được hiển thị. Vui lòng chọn một tài khoản để sử dụng cho kết nối.</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Khi bạn chọn một tài khoản, "RPA CLOUD" sẽ yêu cầu quyền truy cập thay cho bạn. Đồng ý cấp quyền truy cập trên cho "RPA CLOUD" và nhấp vào "Cho phép".</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>Bạn sẽ thấy 1 thẻ Calendar sau khi kết nối được tạo thành công.</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_5} width="50%"/>
            </Zoom>
            <p>Sử dụng <strong>Provider ID</strong> có trong thẻ này để thực hiện các bước trong Calendar.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(Vi);